// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import YS from './YS-frame/YS.js'
import VueBus from './common/js/bus.js'
import {HTTPServer} from '@/common/js/ajax.js'
/** 过滤器 */
import * as filters from '@/filter/filter.js'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.config.productionTip = false
Vue.prototype.YS = YS
Vue.prototype.$http = HTTPServer
Vue.use(VueBus)
Vue.use(Element)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js